(function($) {
$(function(){

  /*****
    Set some global variables
  *****/
  var template_url = $('#template_url').val();


  /*****
    Auto-size <textarea>'s
  *****/
  autosize($('textarea'));

  /*****
    Form AJAX
  *****/
  // But first, a little hack to toggle a class <select> element when the selected option isnt the [disabled] one
  // $('select').on('change', function(){
  //   var selected_elem = $(this).find('option:selected');
  //   if (selected_elem.attr('value')) {
  //     $(this).addClass('option-selected');
  //   }
  // });

  $('[data-ajax-form]').on('submit', function(e){
    e.preventDefault();
    var self = $(this);

    self.find('required').each(function(){
      if ($(this).is(':invalid')) {
        console.log($(this).attr('name') + ' is invalid');
        return false;
      }
    });

    var fields = self.serialize();

    self.find('button[type="submit"]').prop('disabled', true);

    $.ajax({
      method: "GET",
      url: template_url + '/_form_send.php',
      data: fields,
      // complete: function(){
      //   console.log(fields);
      //   console.log(this.url);
      // },
      success: function(msg) {
        // console.log(msg);
        setTimeout(function(){
          self.find("input[type=text], input[type=email]").val("").prop('disabled', true);
          self.find("textarea").val("").prop('disabled', true).removeAttr('style');

          self.find('button[type="submit"]').text('Sent');
        }, 400);
      }
    });

  });

});
})(jQuery);
